var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help-text text-default",class:{ noselect: !!_vm.noSelect },staticStyle:{"word-break":"break-word"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }